import { useEffect, useRef, useSyncExternalStore } from "react";

// Registro global de pedidos de pantalla completa: un solo loader visible a la vez.
const reqs = new Map();
const subs = new Set();
let snap = null;
let seq = 0;
const emit = () => {
  const first = reqs.values().next().value;
  snap = first ? { ...first } : null;
  subs.forEach((f) => f());
};

export const fullLoader = {
  start(opts = {}) {
    const id = ++seq;
    reqs.set(id, { progress: null, step: 0, steps: "page", ...opts });
    emit();
    return {
      update: (patch) => { if (reqs.has(id)) { reqs.set(id, { ...reqs.get(id), ...patch }); emit(); } },
      end: () => { reqs.delete(id); emit(); },
    };
  },
};

export function useFullLoaderState() {
  return useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => snap);
}

export function useFullLoader(active, opts) {
  const { progress = null, step = 0, steps = "page", onRetry } = opts || {};
  const handle = useRef(null);
  useEffect(() => {
    if (!active) return undefined;
    handle.current = fullLoader.start({ progress, step, steps, onRetry });
    return () => { handle.current.end(); handle.current = null; };
  }, [active]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    handle.current?.update({ progress, step });
  }, [progress, step]);
}

// Envuelve un proceso pesado (Nivel A). `fn` recibe `update({progress, step})`.
export async function withFullLoader(fn, opts) {
  const h = fullLoader.start(opts);
  try { return await fn(h.update); } finally { h.end(); }
}
